import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { LocalStorageService } from 'ngx-webstorage';
import {AppConfigService} from "../../../../../core/services/config.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-edit-responsable-ofa',
  templateUrl: './edit-responsable-ofa.component.html',
  styleUrls: ['./edit-responsable-ofa.component.css'],
})
export class EditResponsableOfaComponent implements OnInit {
  @Input() type;
  @Input() structure;
  @Input() agents;

  public API_URL: any;
  public _respo_ofa: any;


  constructor(
    public activeModal: NgbActiveModal,
    private storage: LocalStorageService,
    private _loader: LoadingBarService,
    private _service: AppService,
    private sharedService: SharedDataService,
    private toastrService: ToastrService,
    public configService: AppConfigService
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
  }

  ngOnInit() {
  }


  public confirmAffectation(): void {
    let data, actionFunction;
    const action = this.type;
    if (action === 'structure') {
      data = {
        'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected'),
        'agent_id': this._respo_ofa?.id,
        'structure_id': this.structure?.id,
      };
      actionFunction = this._service.postData(`gestion-ofas/affectations/affecter-responsable-ofa-structure`, data);
    } else {
      data = {
        'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected'),
        'responsable_ofa_matricule': this._respo_ofa?.matricule,
        'fiche_ofa_id': this.structure?.id,
      };
      actionFunction = this._service.postData(`gestion-ofas/affectations/affecter-responsable-ofa-agent`, data);
    }
    this._loader.start();
    actionFunction.subscribe({
      next: (res: any) => {
        this._loader.stop();
        this.toastrService.success(res.message);
        this.refreshDatatable();
        this.activeModal.close();
      },
      error: (error) => {
        this._loader.stop();
        this.toastrService.error(error.error.message);
      }
    })
  }

  public refreshDatatable(): void {
    this.sharedService.sendRefreshTableHAffectations();
  }

}
